import axios from 'axios'

const server_path = process.env.VUE_APP_HOST
const server_sensor_path = "https://api.m2msystemsource.com/v1/"
//	https://api.m2msystemsource.com/v1/alerts/jPYfyyrSE
const sensing_name = "866039040845977"

export function getData(url){
  return axios
      .get(server_path + url)
      .then(res => res)
      .catch(error => error)
}

export function setData(url,data){
  return axios
      .post(server_path + url, data)
      .then(res => res)
      .catch(error => error)
}

export function putData(url,id,data){
  return axios
      .put(server_path + url + id + "/", data)
      .then(res => res)
      .catch(error => error)
}

export function deleteData(url,id){
  return axios
      .delete(server_path + url + id + "/")
      .then(res => res)
      .catch(error => error)
}

export function newReservation(url,data) {
  return axios
    .post(server_path + url, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

export function  uploadDoc(url,file,documentType) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('documentType', documentType)
  // data.forEach(item => {
  //   formData.append(item.name,item.file)
  // });
  return axios
    .post(server_path + url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

export function updateAction(expedient, action, status, id){
  var containerId = 'CONT' + expedient.substring(3)
  var url = 'expedientes/' + expedient + '/actions/'
  var objToSend = {
    'type': action,
    'status': status,
    'id': id,
    'containerId': containerId
  }
  return setData(url, objToSend)
  .then(res=> res)
  .catch(error => error)
}

export function login(user) {
  const url = server_path + 'login/'
  return axios
      .put(url, user)
      .then(res => res)
      .catch(error => error)
}

export function  getSensorGeneral(param) {
  return axios
    .get(server_sensor_path + 'devices/' + sensing_name + param, {
      headers: {
        "Authorization": "Basic Q1ROQVZBTDpjdG5hdmFs"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

export function  getSensorSensing(param) {
  return axios
    .get(server_sensor_path + 'devices/' + 'sensing/' +sensing_name + param, {
      headers: {
        "Authorization": "Basic Q1ROQVZBTDpjdG5hdmFs"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

export function  putSensorData(body) {
  return axios
    .put(server_sensor_path + 'devices/' + sensing_name, body, {
      headers: {
        "Authorization": "Basic Q1ROQVZBTDpjdG5hdmFs"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

export function  getAlertData(id,param) {
  return axios
    .get(server_sensor_path + 'alerts/'+ id + param, {
      headers: {
        "Authorization": "Basic Q1ROQVZBTDpjdG5hdmFs"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

export function  putAlertData(id, body) {
  return axios
    .put(server_sensor_path + 'alerts/' + id,body, {
      headers: {
        "Authorization": "Basic Q1ROQVZBTDpjdG5hdmFs"
      },
    })
    .then(res=> res)
    .catch(error => error);
}

